<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { fly } from 'svelte/transition';
  import { clickOutside } from '../../../../utils/clickOutside.js';
  import { signInWithGoogle, signInWithMicrosoft } from '../../../../store/auth.store';

  const dispatch = createEventDispatcher();

  export let loginPanel = false;
  export let twoFactAuthPanel = false;
  export let loginError = '';
  export let verificationCode = '';
</script>

{#if loginPanel}
  <div
    transition:fly={{ y: -200, duration: 500 }}
    class="sign-login-panel fixed z-10 border-b border-gray-300 bg-white shadow-lg justify-center p-5"
    use:clickOutside
    on:click_outside={() => dispatch('close')}
  >
    <div class:hidden={twoFactAuthPanel}>
      {#if loginError}
        <p class="mb-4">{loginError}</p>
      {/if}
      <div class="sign-login-panel__cards flex flex-wrap gap-6 justify-center">
        <div class="sign-login-panel__card flex flex-col items-center border rounded-lg p-4 w-56 shadow-sm hover:shadow-md transition">
          <div class="flex items-center gap-3 mb-4">
            <img src="/legalPal_sign_logo.svg" alt="App Logo" class="w-12 mb-3" />
            <p class="text-left text-sm font-medium mb-4">
              Edit, Share, <br /> Sign, 100% <br /> for Free
            </p>
          </div>
          <button
            on:click={signInWithGoogle}
            class="flex items-center border border-gray-300 rounded px-3 py-1 w-full justify-center text-sm hover:bg-gray-100"
          >
            <img src="/Google__G__Logo.svg.png" alt="Google" class="w-4 h-4 mr-2" />
            Sign in with Google
          </button>
        </div>
        <div class="sign-login-panel__card flex flex-col items-center border rounded-lg p-4 w-56 shadow-sm hover:shadow-md transition">
          <div class="flex items-center gap-3 mb-4">
            <img src="/legalPal_sign_logo.svg" alt="App Logo" class="w-12 mb-3" />
            <p class="text-left text-sm font-medium mb-4">
              #1 Signature <br /> App for <br /> Lawyers
            </p>
          </div>
          <button
            on:click={signInWithMicrosoft}
            class="flex items-center border border-gray-300 rounded px-3 py-1 w-full justify-center text-sm hover:bg-gray-100"
          >
            <img src="/microsoft_logo.png" alt="Microsoft" class="w-4 h-4 mr-2" />
            Sign in with Microsoft
          </button>
        </div>
      </div>
    </div>
    <div class:hidden={!twoFactAuthPanel}>
      <input
        placeholder="Verification Code"
        type="text"
        class="flex-grow bg-transparent border rounded w-full mb-4 py-1 px-3"
        bind:value={verificationCode}
      />
      <div class="flex justify-center items-center w-full">
        <button
          on:click={() => dispatch('close')}
          class="w-30 bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-3 md:px-4 mr-3 md:mr-4 rounded"
        >
          Cancel
        </button>
        <button
          class="w-30 bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3 md:px-4 mr-3 md:mr-4 rounded"
        >
          Verify
        </button>
      </div>
    </div>
  </div>
{/if}

<style>
  .sign-login-panel {
    top: 60px;
    left: 50%;
    transform: translateX(-50%);
    width: min(640px, calc(100vw - 24px));
    border-radius: 12px;
  }

  @media (max-width: 767px) {
    .sign-login-panel {
      top: 3.75rem;
      width: calc(100vw - 16px);
      max-height: calc(100vh - 5rem);
      overflow-y: auto;
      padding: 1rem;
    }

    .sign-login-panel__cards {
      flex-direction: column;
      align-items: stretch;
      gap: 1rem !important;
    }

    .sign-login-panel__card {
      width: 100% !important;
    }
  }
</style>
